var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useMemo } from 'react';
import { Checkbox, Avatar, Badge } from '@aptive-env/storybook';
import Filters from 'components/Filters';
import TableHeader from 'components/TableHeader';
import TableFooter from 'components/TableFooter';
import styles from './index.module.scss';
import Direction from 'components/Direction';
import LicenseModal from './License';
import ViewDetailDrawer from './ViewDetail';
import { fetchSalesRepresentatives, exportSalesRepresentatives, fetchStates, fetchLicense, fetchSeasons, fetchTeams, fetchLicenseAttachments } from 'services';
import '../../index.scss';
var sortableTHeadClassName = 'relative flex items-center gap-2 cursor-pointer text-xs uppercase tracking-[0.03em] p-3 text-gray-600 hover:text-gray-950 [&_svg]:hover:stroke-[#030712]';
var SalesRepresentativesView = function () {
    var _a = useState([]), states = _a[0], setStates = _a[1];
    var _b = useState([]), seasons = _b[0], setSeasons = _b[1];
    var _c = useState([]), teams = _c[0], setTeams = _c[1];
    var _d = useState(false), isAllChecked = _d[0], setIsAllChecked = _d[1];
    var _e = useState([]), salesRepresentatives = _e[0], setSalesRepresentatives = _e[1];
    var _f = useState({}), filter = _f[0], setFilter = _f[1];
    var _g = useState(''), search = _g[0], setSearch = _g[1];
    var _h = useState({ name: '', direction: 1 }), sort = _h[0], setSort = _h[1];
    var _j = useState(1), currentPage = _j[0], setCurrentPage = _j[1];
    var _k = useState(10), pageSize = _k[0], setPageSize = _k[1];
    var _l = useState(0), totalCount = _l[0], setTotalCount = _l[1];
    var _m = useState(false), isLicenseModalOpen = _m[0], setIsLicenseModalOpen = _m[1];
    var _o = useState(null), selectedSalesRepresentative = _o[0], setSelectedSalesRepresentative = _o[1];
    var _p = useState(false), isSalesRepresentativeViewOpen = _p[0], setIsSalesRepresentativeViewOpen = _p[1];
    var _q = useState(null), selectedLicense = _q[0], setSelectedLicense = _q[1];
    var _r = useState([]), salesRepresentativeLicenses = _r[0], setSalesRepresentativeLicenses = _r[1];
    var _s = useState([]), selectedLicenseAttachments = _s[0], setSelectedLicenseAttachments = _s[1];
    var _t = useState(true), isLoading = _t[0], setIsLoading = _t[1];
    var filterOptions = useMemo(function () {
        return {
            season: { name: 'Season', items: seasons.map(function (season) { return season.name; }) },
            team: { name: 'Team', items: teams.map(function (team) { return team.name; }) },
            license: { name: 'License', items: ['Licensed', 'Unlicensed'] },
            filters: { name: 'Filters' },
            download: { name: 'Download' }
        };
    }, [seasons, teams]);
    var selectedSeason = useMemo(function () { return seasons.find(function (season) { return season.name === filter.season; }); }, [filter.season, seasons]);
    var selectedTeam = useMemo(function () { return teams.find(function (team) { return team.name === filter.team; }); }, [filter.team, teams]);
    var filterLicense = useMemo(function () { return filter.license === 'Licensed' ? 1 : filter.license === 'Unlicensed' ? 0 : undefined; }, [filter.license]);
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var salesRepresentativesResponse, tempSalesRepresentatives;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, fetchSalesRepresentatives({
                            season_id: (_a = selectedSeason === null || selectedSeason === void 0 ? void 0 : selectedSeason.id) !== null && _a !== void 0 ? _a : undefined,
                            team_id: (_b = selectedTeam === null || selectedTeam === void 0 ? void 0 : selectedTeam.id) !== null && _b !== void 0 ? _b : undefined,
                            license: filterLicense,
                            search: search || undefined,
                            sortBy: sort.name || undefined,
                            orderBy: sort.name ? (sort.direction === 1 ? 'asc' : 'desc') : undefined,
                            page: currentPage,
                            per_page: pageSize,
                        })];
                case 1:
                    salesRepresentativesResponse = _c.sent();
                    tempSalesRepresentatives = salesRepresentativesResponse.result.reps.map(function (salesRepresentative) {
                        salesRepresentative.selected = false;
                        return salesRepresentative;
                    });
                    setSalesRepresentatives(tempSalesRepresentatives);
                    setTotalCount(salesRepresentativesResponse._metadata.pagination.total);
                    setIsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchInitialValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, statesResponse, seasonsResponse, teamsResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchStates(),
                        fetchSeasons(),
                        fetchTeams()
                    ])];
                case 1:
                    _a = _b.sent(), statesResponse = _a[0], seasonsResponse = _a[1], teamsResponse = _a[2];
                    setStates(statesResponse.result.states);
                    setSeasons(seasonsResponse.result.seasons);
                    setTeams(teamsResponse.result.teams);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchInitialValues();
    }, []);
    useEffect(function () {
        if (currentPage !== 1)
            setCurrentPage(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedSeason, selectedTeam, filterLicense, search]);
    useEffect(function () {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, pageSize, sort]);
    var toggleAll = function (event) {
        event.preventDefault();
        setIsAllChecked(!isAllChecked);
        var updatedSalesRepresentatives = __spreadArray([], salesRepresentatives, true);
        updatedSalesRepresentatives.forEach(function (salesRepresentative) {
            salesRepresentative.selected = !isAllChecked;
        });
        setSalesRepresentatives(updatedSalesRepresentatives);
    };
    var toggleOne = function (event, id) {
        event.preventDefault();
        event.stopPropagation();
        var isAllChecked = true;
        var updatedSalesRepresentatives = __spreadArray([], salesRepresentatives, true);
        updatedSalesRepresentatives.forEach(function (salesRepresentative) {
            if (salesRepresentative.id === id) {
                salesRepresentative.selected = !salesRepresentative.selected;
            }
            isAllChecked = isAllChecked && salesRepresentative.selected;
        });
        setIsAllChecked(isAllChecked);
        setSalesRepresentatives(updatedSalesRepresentatives);
    };
    var onHandleSort = function (name) {
        setSort({ name: name, direction: sort.name === name ? -sort.direction : 1 });
    };
    var handleClickView = function (salesRepresentative) {
        setSelectedSalesRepresentative(salesRepresentative);
        setIsSalesRepresentativeViewOpen(true);
    };
    var handleDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var exportResponse, blob, a, clickEvt;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, exportSalesRepresentatives()];
                case 1:
                    exportResponse = _a.sent();
                    blob = new Blob([exportResponse], { type: 'text/csv' });
                    a = document.createElement('a');
                    a.download = 'sales-representatives.csv';
                    a.href = window.URL.createObjectURL(blob);
                    clickEvt = new MouseEvent('click', {
                        view: window,
                        bubbles: true,
                        cancelable: true
                    });
                    a.dispatchEvent(clickEvt);
                    a.remove();
                    return [2 /*return*/];
            }
        });
    }); };
    var onLicenseAdd = function () {
        setSelectedLicense(null);
        setIsLicenseModalOpen(true);
    };
    var onLicenseEdit = function (license) { return __awaiter(void 0, void 0, void 0, function () {
        var licensesResponse, uploadedAttachment;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchLicense(license.license_id)];
                case 1:
                    licensesResponse = _a.sent();
                    return [4 /*yield*/, fetchLicenseAttachments(license.license_id)];
                case 2:
                    uploadedAttachment = _a.sent();
                    setSelectedLicense(licensesResponse.result.license);
                    setSelectedLicenseAttachments(uploadedAttachment.result.attachments);
                    setIsLicenseModalOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: "flex flex-col h-0 grow overflow-hidden p-3" }, { children: [_jsxs("div", __assign({ className: "flex justify-between items-center h-[70px] px-3" }, { children: [_jsx("h1", __assign({ className: "text-[32px] leading-10" }, { children: "Sales Representatives" })), _jsx(Filters, { values: filter, options: filterOptions, onChange: function (value) { return setFilter(__assign(__assign({}, filter), value)); }, onDownload: handleDownload })] })), _jsxs("div", __assign({ className: "flex flex-col flex-1 px-3 pb-3 overflow-hidden" }, { children: [_jsx(TableHeader, { search: search, setSearch: setSearch, addLabel: "Add License", addNewModalOpen: onLicenseAdd }), _jsxs("div", __assign({ className: "flex flex-col overflow-hidden border-l border-r border-gray-200" }, { children: [_jsxs("div", __assign({ className: "flex flex-none gap-[34px] bg-gray-50 border-b border-gray-200" }, { children: [_jsx("div", __assign({ className: "flex justify-center items-center w-[48px]" }, { children: _jsx(Checkbox, { checked: isAllChecked, onClick: toggleAll, className: styles.checkBox }) })), _jsx("div", __assign({ className: "w-[74px] text-center text-xs text-gray-600 uppercase tracking-[0.03em] p-3" }, { children: "Photo" })), _jsxs("div", __assign({ className: "grow ".concat(sortableTHeadClassName, " ").concat(sort.name === 'name' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('name'); } }, { children: [_jsx("span", { children: "Name" }), _jsx(Direction, { sort: sort.name === 'name' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "justify-end w-[90px] ".concat(sortableTHeadClassName, " ").concat(sort.name === 'id' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('id'); } }, { children: [_jsx("span", { children: "Id" }), _jsx(Direction, { sort: sort.name === 'id' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "grow ".concat(sortableTHeadClassName, " ").concat(sort.name === 'team' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('team'); } }, { children: [_jsx("span", { children: "Team" }), _jsx(Direction, { sort: sort.name === 'team' ? sort.direction : 0 })] })), _jsxs("div", __assign({ className: "justify-center w-[180px] uppercase ".concat(sortableTHeadClassName, " ").concat(sort.name === 'license' ? 'text-gray-950' : ''), onClick: function () { return onHandleSort('license'); } }, { children: [_jsx("span", { children: "License" }), _jsx(Direction, { sort: sort.name === 'license' ? sort.direction : 0 })] }))] })), _jsxs("div", __assign({ className: "flex flex-col flex-auto overflow-y-auto no-scrollbar" }, { children: [isLoading && (_jsx("div", __assign({ className: "flex w-full h-40 items-center justify-center" }, { children: _jsx("span", __assign({ className: "text-lg" }, { children: "Loading data..." })) }))), !isLoading && salesRepresentatives.length === 0 && (_jsx("div", __assign({ className: "flex w-full h-40 items-center justify-center" }, { children: _jsx("span", __assign({ className: "text-lg" }, { children: "No data" })) }))), !isLoading && salesRepresentatives.length > 0 && salesRepresentatives.map(function (salesRepresentative) {
                                        var _a;
                                        return (_jsxs("div", __assign({ className: "flex gap-[34px] border-b border-gray-200 bg-white cursor-pointer last:border-none", onClick: function () { return handleClickView(salesRepresentative); } }, { children: [_jsx("div", __assign({ className: "flex justify-center items-center w-[48px]" }, { children: _jsx(Checkbox, { checked: salesRepresentative.selected, onClick: function (event) { return toggleOne(event, salesRepresentative.id); }, className: styles.checkBox }) })), _jsx("div", __assign({ className: "flex justify-center items-center w-[74px] text-center p-3" }, { children: _jsx(Avatar, { size: "medium", imgSrc: salesRepresentative.avatar_url }) })), _jsx("div", __assign({ className: "flex items-center flex-1 text-sm text-gray-600 p-3" }, { children: salesRepresentative.name })), _jsx("div", __assign({ className: "flex items-center justify-end text-sm text-gray-600 w-[87px] p-3" }, { children: salesRepresentative.id })), _jsx("div", __assign({ className: "flex items-center flex-1 text-sm text-gray-600 p-3" }, { children: (_a = salesRepresentative.team) === null || _a === void 0 ? void 0 : _a.name })), _jsx("div", __assign({ className: "flex items-center justify-center w-[180px] text-center text-sm text-gray-600 p-3" }, { children: _jsxs(Badge, __assign({ size: "small", color: "".concat(salesRepresentative.license_available && salesRepresentative.license_available > 0 ? 'success' : 'error'), className: "!text-xs !font-normal" }, { children: [salesRepresentative.license_available, "/", salesRepresentative.license_assigned] })) }))] }), salesRepresentative.id));
                                    })] }))] })), _jsx(TableFooter, { page: currentPage, setPage: setCurrentPage, pageSize: pageSize, setPageSize: setPageSize, totalResults: totalCount })] })), isLicenseModalOpen && (_jsx(LicenseModal, { isOpen: isLicenseModalOpen, onClose: function () { return setIsLicenseModalOpen(false); }, license: selectedLicense, salesRepresentative: selectedSalesRepresentative, setSalesRepresentativeLicenses: setSalesRepresentativeLicenses, selectedLicenseAttachments: selectedLicenseAttachments, states: states })), isSalesRepresentativeViewOpen && (_jsx(ViewDetailDrawer, { isOpen: isSalesRepresentativeViewOpen, onClose: function () {
                    setIsSalesRepresentativeViewOpen(false);
                    setSelectedSalesRepresentative(null);
                }, salesRepresentative: selectedSalesRepresentative, salesRepresentativeLicenses: salesRepresentativeLicenses, setSalesRepresentativeLicenses: setSalesRepresentativeLicenses, states: states, onLicenseAdd: onLicenseAdd, onLicenseEdit: onLicenseEdit }))] })));
};
export default SalesRepresentativesView;
